import { QueryClient } from '@tanstack/react-query';

import { ApiError } from './api';

/**
 * QueryClient for the app's server state — **a new one per router** (router.tsx).
 * The server builds one per request so one visitor's responses never land in
 * another request's cache; the browser builds one once.
 * Suspense is enabled by default so reads can use useSuspenseQuery
 * (paired with Error Boundaries) per the frontend coding rules.
 */
export function createQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        // Never retry client errors (4xx) — they won't fix themselves and a
        // retried 401 just delays the login redirect (AC-1.2). Only retry once
        // for transient (network / 5xx) failures.
        retry: (failureCount, error) => {
          if (error instanceof ApiError && error.status >= 400 && error.status < 500) {
            return false;
          }
          return failureCount < 1;
        },
        staleTime: 30_000,
        refetchOnWindowFocus: false,
      },
    },
  });
}
